import React from "react"
import PropTypes from "prop-types"

// Components
import Header from "./header"
import Footer from "./footer"

// Libs
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

// Img
import WhatsAppIcon from '../images/whatsapp-icon.png'

function Layout({ children }) {
  return (
    <div className="font-sans text-gray-900 relative">
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Header />
      <main>
        {children}
      </main>
      <Footer />
      <div className="fixed" style={{ bottom: "55px", right: "25px" }}>
        <a href="https://wa.me/+584122832766">
          <img width={75} height={75} src={WhatsAppIcon} />
        </a>
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
